import { render, staticRenderFns } from "./Corteva.vue?vue&type=template&id=1684356d&"
import script from "./Corteva.vue?vue&type=script&lang=js&"
export * from "./Corteva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports